<template>
  <div class="instantWrap">
    <div class="z-flex-c head">
      <!-- <div class="title">即时工单提示</div> -->
      <div class="title">{{ prop.instantItem.title }}</div>
      <div class="icon"><CloseOutlined @click="() => emit('instantClose', index)" /></div>
    </div>
    <div class="content">
      {{ prop.instantItem.tipMsg }}
    </div>
    <div class="footer">
      <a-button @click="emit('instantClose', prop.index)">知道了</a-button>
      <a-button
        type="primary"
        :loading="confirmLoading"
        style="margin-left: 16px"
        @click="handleOk"
      >
        去处理
      </a-button>
    </div>
  </div>
</template>
<script setup>
import { CloseOutlined } from '@ant-design/icons-vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { defineProps, defineEmits, ref } from 'vue'
import { workOrderDetail } from '@/api/Todo/index.js'

import useOrder from '@/views/WorkPlace/components/WorkOrder/hooks/useOrder.js'
import { message } from 'ant-design-vue'
const prop = defineProps({
  index: {
    type: Number,
    default: 0
  },
  instantItem: {
    type: Object,
    default: () => {}
  }
})
const router = useRouter()
const route = useRoute()
const store = useStore()
const { changeToProcess } = useOrder()

const goDealingOrder = () => {
  if (route.path !== '/workplace') {
    router.push('/workplace')
    store.commit('workOrder/SET_CHART_ID', String(prop.instantItem.groupId))
    changeToProcess()
  } else {
    store.commit('workOrder/SET_CHART_ID', String(prop.instantItem.groupId))
    changeToProcess()
  }
}

const confirmLoading = ref(false)
const handleOk = async () => {
  confirmLoading.value = true
  try {
    const { workOrder } = await workOrderDetail({
      workOrderId: prop.instantItem.workOrderID
    })
    confirmLoading.value = false
    if (workOrder.workOrderStatus === 101) {
      goDealingOrder()
    } else {
      message.warning('工单状态已变更！')
    }
    emit('instantClose', prop.index)
  } catch (error) {
    confirmLoading.value = false
    emit('instantClose', prop.index)
  }
}

const emit = defineEmits(['instantClose'])
</script>
<style scoped lang="scss">
.instantWrap {
  background: #fff;
  border-radius: 6px;
  width: 384px;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 3px;
  margin-bottom: 10px;
  box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.08), 0 5px 6px 0px rgba(0, 0, 0, 0.12),
    0 29px 18px -3px rgba(0, 0, 0, 0.05);

  .head {
    padding: 10px 18px;
    border-bottom: 2px solid #f0f0f0;
  }

  .title {
    font-weight: 500;
    font-size: 15px;
    color: #000000d9;
  }
  .icon {
    color: #000000a6;
    cursor: pointer;
    font-size: 16px;
  }
  .content {
    padding: 10px 18px;
    font-weight: 500;
    font-size: 14px;
    color: #000000a6;
  }

  .footer {
    padding: 10px 18px;
    // border-top: 2px solid #f0f0f0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
